import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TempFilesSnackbarConfig } from './temp-files-snackbar.config';

@Injectable({
  providedIn: 'root',
})
export class TempFileSnackbarsService {
  private snackbar = inject(MatSnackBar);

  public failedUploadFile(): void {
    this.snackbar.open(
      TempFilesSnackbarConfig.failedUploadFile.message,
      TempFilesSnackbarConfig.failedUploadFile.closeBtn,
      TempFilesSnackbarConfig.failedUploadFile.config
    );
  }

  public notAllowedFileType(): void {
    this.snackbar.open(
      TempFilesSnackbarConfig.notAllowedFileType.message,
      TempFilesSnackbarConfig.notAllowedFileType.closeBtn,
      TempFilesSnackbarConfig.notAllowedFileType.config
    );
  }
}
